<template>
  <div>
    <!-- modal -->
    <b-modal id="activityFormModal" ref="activityFormModal" centered size="lg" no-close-on-backdrop :title=" $t('activity.info')" :cancel-title=" $t('others.cancel_title')"
      :ok-title=" $t('others.ok_title')" cancel-variant="outline-secondary" @ok.prevent="addOrUpdate">
      <validation-observer ref="simpleRules">
        <b-row>
          <b-col class="col-lg-6">
            <b-form>
                <label for="activity-code-input">{{ $t('activity.code') }}</label>
                <b-form-group>
                  <validation-provider #default="{ errors }" :name=" $t('activity.code')" rules="required" >
                    <b-form-input id="activity-code-input" size="sm" v-model="code" maxlength="4" :state="errors.length > 0 ? false:null"/>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
            </b-form>
          </b-col>
          <b-col class="col-lg-6">
            <b-form>
                <label for="activity-name-input">{{ $t('activity.name') }}</label>
                <b-form-group>
                  <validation-provider #default="{ errors }" :name=" $t('activity.name')" rules="required" >
                    <b-form-input id="activity-name-input" size="sm" v-model="name" maxlength="50" :state="errors.length > 0 ? false:null"/>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
            </b-form>
          </b-col>
        </b-row>
      </validation-observer>
    </b-modal>
  </div>
</template>
<script>
export default {
  props: {
    getActivityList: {type: Function},
  },
  data() {
    return {
      id: 0,
      code: '',
      name: '',
    }
  },
  methods: {
    showInfo(id) {
      this.$refs['activityFormModal'].show()
      this.id = id
      const data = {id: this.id}
      const controller = {name: 'Activity'}
      const payload = {data: data, controller: controller}
      this.$store.dispatch('moduleAuth/getInfo', payload).then((response) => {
        if (response.data.resultStatus == true) {
          this.code = response.data.activity.code
          this.name = response.data.activity.name
        } else {
          this.$bvModal.hide('activityFormModal')
          this.$WarningAlert(response.data.resultMessage)
        }
      })
    },
    addOrUpdate() {
      const data = {id: this.id, code: this.code, name: this.name}
      const controller = {name: 'Activity'}
      const payload = {data: data, controller: controller}
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.$store.dispatch('moduleAuth/save', payload).then((response) => {
            if (response.data.resultStatus == true) {
              this.$bvModal.hide('activityFormModal')
              this.getActivityList()
              this.$SaveAlert()
            } else {
              this.$WarningAlert(response.data.resultMessage)
            }
          })
        }
      })
    },
  }
}
</script>
<style lang="scss">
[dir=ltr] .modal-header .close {
    margin: -0.4rem -0.4rem -0.8rem auto;
}
[dir] label {
    margin-bottom: 0.2857rem;
    font-weight: bold;
}
.modal .modal-content {
    overflow: visible;
    margin-bottom: auto;
}
[dir] .invalid-tooltip {
    padding: 0.4rem 0.775rem!important;
    margin-top: -1.5rem!important;
    background-color: #ea5455!important;
    border-radius: 0.358rem!important;
    left: 20px!important
}
</style>
